import {Injectable} from '@angular/core';
import {DataTabs} from '../../shared/models/tabs-data';
import {GetFormsInvoicesServices} from './get-forms-invoices.services';
import {GetConfigInvoicesService} from './get-config-invoices.service';

@Injectable({
  providedIn: 'root'
})
export class InvoicesDataService {
  adjustmentValue: string;
  constructor(private getFormsInvoicesServices: GetFormsInvoicesServices,
              private getConfigInvoicesService: GetConfigInvoicesService) {
  }

  getHistoriesListData(): DataTabs {
    return {
      dataTabs: [
        {
          titleTab: 'InvoicesHistory',
          contentTab: 'datatableInvoicesHistoryList',
          dataConfig: {
            form: this.getFormsInvoicesServices.getFilterHistory(),
            groupConfigs: this.getConfigInvoicesService.getHistoryFilter(),
            header: {
              icon: 'fad fa-archive',
              text: 'GENERIC_INVOICES_HISTORY',
              rightSideButton : {
                buttonTitle : 'INVOICES_TRIGGER_BUTTON_TITLE',
                buttonIcon: 'fad fa-file-invoice-dollar',
                action: 'ModalTriggerInvoices',
                buttonTitleExtra : 'INVOICES_GET_LAST_NUMBER',
                buttonIconExtra: 'fal fa-list-ol',
                actionTypeExtra: 'ModalLastInvoicesNumber',
              },
            },
            content: [
              {
                name: 'GENERIC_NAME_LABEL',
                prop: 'name',
                sortable: true,
                type: 'text',
              },
              {
                name: 'GENERIC_DATE',
                prop: 'date',
                sortable: true,
                type: 'date'
              },
              {
                name: 'GENERIC_STATUS',
                prop: 'status',
                sortable: true,
                type: 'invoices-status'
              },
              {
                name: 'INVOICES_HISTORY_STARTED',
                prop: 'started',
                sortable: true,
                type: 'date',
              },
              {
                name: 'INVOICES_HISTORY_COMPLETED',
                prop: 'completed',
                sortable: true,
                type: 'date'
              },
              {
                name: 'GENERIC_RECURRENCE',
                prop: 'recurrence',
                sortable: true,
                array: [
                  { id: 1, name: 'Monthly' },
                  { id: 3, name: 'Quarterly' },
                  { id: 6, name: 'Biannual' },
                  { id: 12, name: 'Yearly' },
                  { id: 0, name: 'Anniversary' }
                  ],
                type: 'array'
              },
              {
                name: 'GENERIC_ADJUSTMENT' ,
                prop: '',
                sortable: false,
                type: 'icon',
                icon: {
                  classFn: (row): string => (this.adjustment(row)),
                  tooltip: (this.adjustmentValue = 'annual') ? 'INVOICES_HISTORY_ADJUSTMENT_ANNUAL' : 'INVOICES_HISTORY_ADJUSTMENT_BI'
                }
              },
              {
                name: 'GENERIC_CREATED',
                prop: 'created',
                sortable: true,
                type: 'date'
              },
              {
                name: '',
                prop: '',
                sortable: false,
                type: 'iconModal',
                icon: {
                  modal: 'ValidationFiles',
                  class: 'far fa-file-spreadsheet fa-lg',
                  tooltip:  'BILLING_VALIDATION_FILES',
                  // hide: (row): boolean => ((0 === row.calculationsCount || (row.status.includes('Failed')))
                  //   && (!row.name.includes('Validation'))) ,
                    // show = validation task OR (calculationsCount > 0 && taks is not failed)
                    // hide = not validation task AND (calculationCount == 0 || task is failed)
                  hide: (row): boolean => ((row.calculationsCount > 0 && (!row.status.includes('Failed')))
                    || (row.name.includes('Validation'))) ,
                }
              },
              {
                name: '',
                prop: '',
                sortable: false,
                type: 'iconModal',
                icon: {
                  modal: 'SaleForceFiles',
                  class: 'fab fa-stripe-s',
                  tooltip:  'BILLING_SALES_FORCE_FILES',
                  // hide: (row): boolean => ((0 === row.calculationsCount || (row.status.includes('Failed')))
                  //   && (!row.name.includes('Validation'))) ,
                  // show = validation task OR (calculationsCount > 0 && taks is not failed)
                  // hide = not validation task AND (calculationCount == 0 || calculationCount == null || task is failed)
                  hide: (row): boolean => ((row.calculationsCount > 0 && (!row.status.includes('Failed')))
                    || (row.name.includes('Validation'))) ,
                }
              },
              {
                name: '',
                prop: '',
                sortable: false,
                type: 'iconModal',
                icon: {
                  modal: 'modalValidation',
                  class: 'fad fa-clipboard-check fa-lg',
                  tooltip: 'INVOICES_VALIDATION_BUTTON_TITLE',
                  // hide: (row): boolean => ((row.name.includes('Validation')) || (row.calculationsCount === 0 || row.calculationsCount === null)
                  //   || !row.status.includes('Completed')) ,
                  // show = not validation task AND calculationsCount > 0 && taks is completed
                  // hide = validation task OR (calculationCount == 0 || calculationCount == null) OR task is not completed
                  hide: (row): boolean => ((!row.name.includes('Validation')) && (row.calculationsCount > 0 && row.calculationsCount !== null)
                    && row.status.includes('Completed')) ,
                }
              },
              {
                name: '',
                prop: '',
                sortable: false,
                type: 'iconModal',
                icon: {
                  modal: 'modalReprocessCalculation',
                  class: 'fad fa-repeat fa-lg',
                  tooltip: 'INVOICES_VALIDATION_REPROCESS_BUTTON_TITLE',
                  // hide: (row): boolean => ((!row.status.includes('Cleared')) || (row.name.includes('Validation'))
                  //   || (row.calculationsCount === 0 || row.calculationsCount === null))
                  // show = not validation task AND task is cleared AND calculationCount > 0
                  // hide = validation task OR (calculationCount == 0 || calculationCount == null) OR task is not cleared
                  hide: (row): boolean => ((row.status.includes('Cleared')) && (!row.name.includes('Validation'))
                    && (row.calculationsCount > 0 && row.calculationsCount !== null))
                }
              },
              {
                name: '',
                prop: '',
                sortable: false,
                type: 'iconModal',
                icon: {
                  modal: 'modalClearValidation',
                  class: 'fal fa-broom fa-lg',
                  tooltip: 'INVOICES_VALIDATION_CLEAR_BUTTON_TITLE',
                  // hide: (row): boolean => ((row.name.includes('Validation')) || (row.status.includes('Cleared'))
                  //   || (row.calculationsCount === 0 || row.calculationsCount === null))
                  // show = not validation task AND task is not cleared AND calculationCount > 0
                  // hide = validation task OR (calculationCount == 0 || calculationCount == null) OR task is cleared
                  hide: (row): boolean => ((!row.name.includes('Validation')) && (!row.status.includes('Cleared'))
                   && (row.calculationsCount > 0 && row.calculationsCount !== null))
                }
              },

            ]
          },
        }
      ]
    }
  }
  getInvoicesDetailListData(): DataTabs {
    return {
      dataTabs: [
        {
          titleTab: 'InvoicesHistory',
          contentTab: 'datatableInvoicesHistoryList',
          dataConfig: {
            form: this.getFormsInvoicesServices.getFilterInvoicesDetail(),
            groupConfigs: this.getConfigInvoicesService.getInvoicesDetailFilter(),
            content: [
              {
                name: 'GENERIC_CODE',
                prop: 'code',
                sortable: true,
                type: 'text',
              },
              {
                name: 'GENERIC_INVOICES_DETAIL_LIST_LOGISTICS_CODE',
                prop: 'logisticCode',
                sortable: true,
                type: 'text'
              },
              {
                name: 'GENERIC_NAME',
                prop: 'name',
                sortable: true,
                type: 'text'
              },
              {
                name: 'GENERIC_COUNT',
                prop: 'count',
                sortable: true,
                type: 'text'
              },
              {
                name: 'GENERIC_INVOICES_DETAIL_LIST_UNITE_PRICE',
                prop: 'unitPrice',
                sortable: true,
                type: 'price',
              },
              {
                name: 'GENERIC_INVOICES_DETAIL_LIST_TOTAL',
                prop: 'total',
                sortable: true,
                type: 'text'
              },
              {
                name: 'GENERIC_CONTRACT_NAME',
                prop: 'contractName',
                sortable: true,
                type: 'routerLink',
                path: 'invoicesDetail',
              },
              {
                name: 'GENERIC_PRODUCT',
                prop: 'productName',
                sortable: true,
                type: 'text'
              }
            ]
          },
        }
      ]
    }
  }

  // tslint:disable-next-line:no-any
  adjustment(row: any): string {
      if (row.adjustmentAnnual) {
        this.adjustmentValue = 'annual';
        return'fal fa-calendar';
      }
      if (row.adjustmentBiannual) {
        this.adjustmentValue = 'bi';
        return 'fad fa-calendar-plus';
      }
      return '';
    }
}
